<template>
  <v-sheet class="camDetailList">
    <resizable-page ref="resPage">
      <template v-slot:header>
        <section
          class="camDetailList_actions"
          :class="{ isSorting: isSorting }"
        >
          <app-text-field
            v-if="!isSorting"
            v-model="query"
            class="camDetailList_search"
            color="dark"
            aria-autocomplete="off"
            autocomplete="off"
            outlined
            full-width
            :hide-details="true"
            :disabled="loading || routeLoading"
            placeholder="カメラの検索"
          />
          <section v-if="isEdit || isSort" class="camDetailList_actions-edit">
            <v-btn class="camDetailList_cancel" @click="handleCancel">
              キャンセル
            </v-btn>
            <v-btn
              class="camDetailList_save"
              :loading="submitLoading"
              @click="saveOrder"
            >
              決定
            </v-btn>
          </section>
        </section>
      </template>
      <template v-slot:table="tableProps">
        <v-skeleton-loader
          v-if="loading || routeLoading"
          :loading="loading || routeLoading"
          type="table"
        ></v-skeleton-loader>
        <v-data-table
          v-else
          class="camDetailList_tbl"
          :height="tableProps.bodyHeight"
          :headers="computedHeaders"
          :items="tableItems"
          hide-default-footer
          disable-pagination
          sort-by="dateTime"
          :fixed-header="true"
        >
          <!-- Table header name template  -->
          <template #[`header.name`]="{ header }">
            <section class="camDetailList_tbl-header--name">
              <div v-if="false">
                <v-text-field
                  v-model="movingIndex"
                  class="listCamsSetting_search listCamsSetting_moveInput"
                  color="dark"
                  aria-autocomplete="off"
                  autocomplete="off"
                  outlined
                  full-width
                  hide-details
                  placeholder=""
                >
                  <v-btn
                    slot="append"
                    width="40"
                    height="23"
                    :disabled="!movingIndex"
                    class="listCamsSetting_move"
                    @click="handleMove"
                  >
                    決定
                  </v-btn>
                </v-text-field>
              </div>
              <app-check
                v-if="isEdit"
                v-model="allSelected"
                class="camDetailList_select-all"
                @input="handleSelectAll"
              />
              <span v-else :class="{ isSorting: isSorting }">{{
                header.text.toUpperCase()
              }}</span>
            </section>
          </template>
          <!-- Table header group template  -->
          <template #[`header.group`]="{ header }">
            <section class="">
              <div v-if="isSort" class="text-right">
                <v-btn text class="" @click="moveSelectedItems('down')">
                  <img src="@/assets/img/ico_arrow_down.svg" class="" alt="" />
                </v-btn>
                <v-btn text class="" @click="moveSelectedItems('up')">
                  <img src="@/assets/img/ico_arrow_up.svg" class="" alt="" />
                </v-btn>
              </div>
              <div v-else>
                {{ header.text }}
              </div>
            </section>
          </template>
          <!-- Table body template  -->
          <template #body="props">
            <draggable
              :list="props.items"
              tag="tbody"
              handle=".hamburger-menu"
              @end="dropCamDetail"
            >
              <tr
                v-for="(item, index) in props.items"
                :key="index"
                :class="{ 'd-none': !item.active && !isSelecting }"
                @click="handleGroup(item)"
              >
                <td class="text-start">
                  <div class="listCamsSetting_tbl-nameWrapper">
                    <app-check
                      v-if="isSort"
                      v-model="item.selected"
                      no-circle
                      check-index
                      :index-value="index + 1"
                    />
                    <tooltip :classes="'firmwareDetails_tooltip'">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          v-bind="attrs"
                          class="camDetailList_tbl-name text-truncate"
                          style="max-width: 100%"
                          v-on="on"
                        >
                          <app-check
                            v-if="isEdit"
                            v-model="item.active"
                            @input="checkAllSelected"
                          />
                          <span>{{ item.name }}</span>
                        </div>
                      </template>
                      <h2>{{ item.name }}</h2>
                    </tooltip>
                  </div>
                </td>
                <td v-if="!isSort" class="text-start">
                  <tooltip :classes="'firmwareDetails_tooltip'">
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        v-bind="attrs"
                        class="camDetailList_tbl-account text-truncate"
                        style="max-width: 100%"
                        v-on="on"
                      >
                        {{ item.group }}
                      </div>
                    </template>
                    <h2>{{ item.group }}</h2>
                  </tooltip>
                </td>
                <td v-else class="text-right">
                  <!-- <span v-if="isSort" class="hamburger-menu">≡</span> -->
                </td>
              </tr>
            </draggable>
          </template>
          <!-- ----------------- -->
          <!-- Table no data -->
          <template v-slot:no-data>
            <tr style="visibility: hidden" />
          </template>
          <!-- ----------------- -->
        </v-data-table>
      </template>
    </resizable-page>
  </v-sheet>
</template>

<script>
import { MimeTypes } from '@/globals/enums';
import { mapActions, mapGetters, mapState } from 'vuex';
import { videoService } from '@/services/video.service';
import draggable from 'vuedraggable';
import uniqBy from 'lodash/uniqBy';
import { sortObjectsByIds } from '@/utils/helpers';
export default {
  name: 'CamDetailList',
  components: {
    draggable,
  },
  props: {
    routeLoading: {
      type: Boolean,
      default: false,
    },
    filteredItems: {
      type: Array,
      default: () => [],
    },
    hideStatus: {
      type: Boolean,
      default: false,
    },
    isSelecting: {
      type: Boolean,
      default: false,
    },
    isSorting: {
      type: Boolean,
      default: false,
    },
    searchQuery: {
      type: String,
      default: () => null,
    },
  },
  data: () => ({
    selectedCams: {},
    allSelected: false,
    oldSelectedCams: {},
    showVideo: true,
    query: null,
    mimeTypes: MimeTypes,
    selectedItems: [],
    clipToolsOpen: false,
    loading: false,
    displayCam: false,
    selectMode: false,
    tableItems: [],
    movingIndex: null,
    initTableItems: [],
    onChangedItems: [],
    submitLoading: false,
  }),
  computed: {
    ...mapGetters('common', {
      items: 'allCamList',
    }),
    ...mapState({
      iamKey: (state) => state.common.iam.accessKeyId,
      cameraById: (state) => state.common.cameraById,
      iamSecret: (state) => state.common.iam.secretAccessKey,
      groupCams: (state) => state.settings.groupCams,
      camWithGroups: (state) => state.settings.camWithGroups,
      groupCamsChecklist: (state) => state.settings.groupCamsChecklist,
      currentHomeGroup: (state) => state.common.currentHomeGroup,
      currentCameraDirectoryId: (state) =>
        state.settings.currentCameraDirectoryId,
    }),
    id() {
      return this.$route.params.id;
    },
    currentGroup() {
      return this.groupCams.find((g) => +g.id === +this.id);
    },
    cams() {
      return this.currentGroup
        ? this.currentGroup.details.map((c) => ({ ...c, name: c.title }))
        : [];
    },
    currentGroupCheckList() {
      return (
        this.groupCamsChecklist.find((g) => +g.id === +this.id)?.details || []
      );
    },
    computedHeaders() {
      return [
        {
          text: 'カメラ名称',
          align: 'start',
          sortable: false,
          value: 'name',
          width: '130',
          class:
            'camDetailList_header-name' + (this.isSorting ? ' isSorting' : ''),
        },
        {
          text: 'カメラグループ',
          align: 'start',
          sortable: false,
          value: 'group',
          width: this.isSort ? '20' : '300',
          class: this.isSort ? 'listCamsSetting_header-grabbing' : '',
        },
      ];
    },
    isEdit: {
      get() {
        return this.isSelecting;
      },
      set(val) {
        this.$emit('update:isSelecting', val);
      },
    },
    isSort: {
      get() {
        return this.isSorting;
      },
      set(val) {
        this.$emit('update:isSorting', val);
      },
    },
  },
  watch: {
    currentGroupCheckList: {
      handler: function (val) {
        this.tableItems = sortObjectsByIds(
          val.map((g) => g.id),
          this.tableItems,
          false
        );
        this.initTableItems = sortObjectsByIds(
          val.map((g) => g.id),
          this.initTableItems,
          false
        );
      },
      deep: true,
    },
    query(val) {
      if (val) {
        this.tableItems = this.initTableItems
          .filter((g) => {
            return g.name.toLowerCase().includes(val.toLowerCase());
          })
          .map((c, i) => {
            let active = c.active;
            const changedItem = this.onChangedItems.find(
              (item) => item.id === c.id
            );
            if (changedItem) {
              active = changedItem.active;
            }
            return {
              id: c.id,
              name: c.name,
              event: [
                { label: '動体検知' },
                { label: 'ライン通過検知', disabled: i % 2 === 0 },
                { label: 'エリア立入検知' },
                { label: '滞留検知' },
                { label: '混雑検知', disabled: i % 3 === 0 },
              ],
              cam: this.cameraById[c.id],
              group:
                this.camWithGroups && this.camWithGroups[c.id]
                  ? this.camWithGroups[c.id].map((g) => g.name).join(' ')
                  : '',
              selected: false,
              active: active,
              groupIds:
                this.camWithGroups && this.camWithGroups[c.id]
                  ? this.camWithGroups[c.id].flatMap((item) => item.id)
                  : [],
            };
          });
      } else {
        this.mapTableItems();
      }
    },
    groupCams: {
      handler: function (val) {
        if (this.isEdit) {
          return;
        }
        const currentGroup = val.find((group) => +group.id === +this.id);
        if (currentGroup) {
          let selectedCams = {};
          currentGroup.details.forEach((cam) => {
            selectedCams = { ...selectedCams, [cam.id]: true };
          });
          this.selectedCams = selectedCams;
          this.oldSelectedCams = { ...this.selectedCams };
          this.checkAllSelected();
        }
      },
      deep: true,
      immediate: true,
    },
    selectedCams: {
      handler: function (val) {
        this.checkAllSelected();
        this.isChanged = this.checkAnyChange(val);
      },
      deep: true,
    },
    isEdit(val) {
      if (val) {
        // store the original order before sorting
        this.initTableItems = this.tableItems.map((item) => ({ ...item }));
        // sort based on items order
        this.tableItems = sortObjectsByIds(
          this.items.map((g) => g.id),
          this.tableItems,
          false
        );
        this.checkAllSelected();
      } else {
        // only restore if there are no changes to save
        if (this.initTableItems.length && !this.onChangedItems.length) {
          const changedStates = new Map(
            this.tableItems.map((item) => [item.id, item.active])
          );

          // restore original order but keep changed states
          this.tableItems = this.initTableItems.map((item) => ({
            ...item,
            active: changedStates.has(item.id)
              ? changedStates.get(item.id)
              : item.active,
          }));

          this.mapTableItems();
        }
      }
    },
    isSort(val) {
      if (val) {
        this.query = null;
        this.mapTableItems();
      }
    },
    filteredItems: {
      handler: function (items) {
        if (items && items.length) {
          this.mapTableItems();
        }
      },
      deep: true,
    },
  },
  created() {
    this.currentCategory = 3;
  },
  mounted() {
    this.query = this.searchQuery;
    this.loading = true;
    this.onChangedItems = [];
    setTimeout(() => {
      this.loading = false;
      this.mapTableItems();
      this.initTableItems = this.tableItems.map((obj) => ({ ...obj }));
    }, 500);
  },
  methods: {
    ...mapActions('settings', [
      'setCurrentSelectedCamsGroup',
      'updateCameraGroup',
    ]),
    ...mapActions('home', ['updateCameraOrder']),
    checkAllSelected() {
      this.tableItems.forEach((camera) => {
        const changedItem = this.initTableItems.find(
          (originalCam) =>
            originalCam.id === camera.id && originalCam.active !== camera.active
        );
        if (!changedItem) {
          this.onChangedItems = this.onChangedItems.filter(
            (item) => item.id !== camera.id
          );
        } else {
          this.onChangedItems.push(camera);
        }
      });
      this.onChangedItems = uniqBy(this.onChangedItems, 'id');
      this.allSelected =
        this.tableItems.filter((s) => s.active).length ===
        this.tableItems.length;
    },
    checkAnyChange(selectedCams) {
      const a = Object.keys(selectedCams).filter((key) => selectedCams[key]);
      const b = Object.keys(this.oldSelectedCams).filter(
        (key) => this.oldSelectedCams[key]
      );
      const diff =
        a.length > b.length
          ? a.filter((e) => !b.includes(e))
          : b.filter((e) => !a.includes(e));
      return diff.length > 0;
    },
    async handleSubmit() {
      try {
        this.submitLoading = true;
        const camsToUpdate = [];
        const updates = [];
        const selectedCamIds = Object.keys(this.selectedCams).filter(
          (key) => this.selectedCams[key]
        );
        this.items.forEach((obj) => {
          const cam = this.cameraById[obj.id];
          let isChanged = false;
          let groupIds =
            cam.tagInfoList && cam.tagInfoList.length
              ? cam.tagInfoList.map((camTag) => +camTag.id)
              : [];
          const thisCamSelected = selectedCamIds.includes(+cam.id);
          if (thisCamSelected && !groupIds.includes(+this.id)) {
            // Whether need to add a group id in camera
            groupIds.push(this.id);
            isChanged = true;
          } else if (!thisCamSelected && groupIds.includes(+this.id)) {
            // Whether need to remove a group id from camera
            groupIds = groupIds.filter((groupId) => +groupId !== +this.id);
            isChanged = true;
          }

          if (isChanged) {
            camsToUpdate.push({
              id: cam.id,
              groupId: groupIds.map((id) => Number(id)),
            });
          }
        });

        camsToUpdate.forEach((camUpdate) => {
          updates.push(this.updateCameraGroup(camUpdate));
        });
        await Promise.all(updates);

        await videoService.getCameraListWithGroup();

        this.$router.push({
          name: 'settings-cams-list',
          params: { group: this.$route.params.group },
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.submitLoading = false;
      }
    },
    handleSelectCam() {
      this.allSelected =
        this.tableItems.filter((s) => s.active).length ===
        this.tableItems.length;
    },
    handleSelectAll(value) {
      this.tableItems.map((item) => (item.active = !!value));
      this.checkAllSelected();
    },
    navigateTo(to) {
      this.$router.push(to);
    },
    toggleDisplayCam() {
      this.$refs.resPage.onResize();
      this.displayCam = !this.displayCam;
    },
    mapTableItems() {
      let initialList = this.initTableItems.length
        ? this.initTableItems
        : this.filteredItems;
      if (this.isSorting) {
        initialList = initialList.filter((item) => item.active);
      }
      const mappedData = initialList.map((c, i) => {
        let active = c.active;
        const changedItem = this.onChangedItems.find(
          (item) => item.id === c.id
        );
        if (changedItem) {
          active = changedItem.active;
        }
        return {
          id: c.id,
          name: c.name,
          event: [
            { label: '動体検知' },
            { label: 'ライン通過検知', disabled: i % 2 === 0 },
            { label: 'エリア立入検知' },
            { label: '滞留検知' },
            { label: '混雑検知', disabled: i % 3 === 0 },
          ],
          cam: this.cameraById[c.id],
          group:
            this.camWithGroups && this.camWithGroups[c.id]
              ? this.camWithGroups[c.id].map((g) => g.name).join(' ')
              : '',
          selected: false,
          active: active,
          groupIds:
            this.camWithGroups && this.camWithGroups[c.id]
              ? this.camWithGroups[c.id].flatMap((item) => item.id)
              : [],
        };
      });

      let activeCamIndex = 0;
      mappedData.forEach((item) => {
        if (item.active) {
          item.activeIndex = activeCamIndex + 1;
          activeCamIndex++;
        } else {
          item.activeIndex = null;
        }
      });

      this.tableItems = mappedData;

      this.checkAllSelected();
    },
    dropCamDetail(item) {
      const element = this.tableItems[item.oldIndex];
      this.tableItems.splice(item.oldIndex, 1);
      this.tableItems.splice(item.newIndex, 0, element);
    },
    async saveOrder() {
      if (this.isSort) {
        try {
          this.submitLoading = true;
          const sortedLayout = this.tableItems.map((item, index) => ({
            cameraId: item.id,
            position: index + 1,
          }));

          const payload = {
            cameraGroupId: +this.id,
            cameraDirectoryId: this.currentCameraDirectoryId,
            sort: sortedLayout,
          };

          await this.updateCameraOrder(payload);
          this.isSort = false;
          this.$emit('handleCancel');
          this.routerPush({
            name: 'settings-cams-list-detail',
            params: {
              id: this.id,
            },
          });
        } catch (error) {
          console.error(error);
        } finally {
          this.submitLoading = false;
        }
      } else if (this.isEdit) {
        // Save updated check list
        if (this.onChangedItems.length) {
          this.loading = true;
          const updates = [];
          this.onChangedItems.forEach((checkedCam) => {
            // Update initial items
            this.initTableItems.map((initItem) => {
              if (checkedCam.id === initItem.id) {
                initItem.active = checkedCam.active;
              }
            });
            // Create updated elements
            let newGroupIds = checkedCam.groupIds || [];
            if (!checkedCam.active) {
              newGroupIds = checkedCam.groupIds.filter((group) => {
                return group !== +this.id;
              });
            } else {
              newGroupIds.push(+this.id);
            }
            newGroupIds = newGroupIds.filter((g) => g);
            updates.push(
              this.updateCameraGroup({
                id: checkedCam.id,
                groupId: newGroupIds,
              })
            );
          });
          this.onChangedItems = [];
          this.query = null;
          updates.length && (await Promise.all(updates));
          await videoService.getCameraListWithGroup();
          this.loading = false;
          this.isEdit = false;
        } else {
          this.handleCancel();
        }
      }
    },
    handleCancel() {
      this.isEdit = false;
      this.query = null;
      this.movingIndex = null;
      this.onChangedItems = [];
      this.mapTableItems();
      this.routerPush({
        name: 'settings-cams-list-detail',
        params: {
          id: this.id,
        },
      });
      this.isSort = false;
      this.$emit('handleCancel');
    },
    handleGroupSort(desc = false) {
      this.tableItems = this.tableItems.sort((a, b) => {
        if (a.selected && !b.selected) {
          return desc ? 1 : -1;
        } else if (!a.selected && b.selected) {
          return desc ? -1 : 1;
        } else {
          return 0;
        }
      });
    },
    handleGroup(item) {
      item.selected = !item.selected;
      const firstSelectedItem = this.tableItems.findIndex(
        (item) => item.selected
      );
      this.movingIndex = firstSelectedItem > -1 ? firstSelectedItem + 1 : null;
      if (this.isEdit) {
        item.active = !item.active;
        this.checkAllSelected();
      }
    },
    handleMove() {
      if (
        /^[1-9]\d*$/.test(this.movingIndex) &&
        +this.movingIndex <= this.tableItems.length
      ) {
        const removedObjects = [];
        const selectedItems =
          this.tableItems.filter((item) => item.selected) || [];
        if (selectedItems.length) {
          selectedItems.forEach((obj) => {
            const index = this.tableItems.findIndex(
              (item) => item.id === obj.id
            );
            if (index !== -1) {
              removedObjects.push(this.tableItems.splice(index, 1)[0]);
            }
          });
          this.tableItems.splice(+this.movingIndex - 1, 0, ...removedObjects);
        }
      }
    },
    moveSelectedItems(direction) {
      const selected = this.tableItems.filter((item) => item.selected);
      const indices = selected.map((item) => this.tableItems.indexOf(item));
      indices.sort((a, b) => a - b);

      if (direction === 'up') {
        const firstIndex = this.tableItems.findIndex((item) => item.selected);
        if (!firstIndex) {
          return;
        }
        indices.forEach((index, i) => {
          if (index > i) {
            this.tableItems.splice(
              index - 1,
              0,
              ...this.tableItems.splice(index, 1)
            );
          }
        });
      } else if (direction === 'down') {
        let lastIndex = -1;
        for (let i = 0; i < this.tableItems.length; i++) {
          if (this.tableItems[i].selected) {
            lastIndex = i;
          }
        }
        if (lastIndex === this.tableItems.length - 1) {
          return;
        }
        indices.reverse().forEach((index, i) => {
          if (index < this.tableItems.length - 1 - i) {
            this.tableItems.splice(
              index + 1,
              0,
              ...this.tableItems.splice(index, 1)
            );
          }
        });
      } else {
        throw new Error(`Invalid direction: ${direction}`);
      }
      selected.forEach((item, i) => {
        item.index = indices[i];
      });
    },
  },
};
</script>

<style lang="scss">
.camDetailList {
  &_select-all {
    margin-right: 10px;
  }
  &_display {
    margin-left: 12px;
    &.theme--light.v-btn.v-btn--has-bg {
      width: 115px;
      height: 23px;
      border-radius: 5px;
      background-color: #dbe2f3;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.08;
      letter-spacing: normal;
      text-align: left;
      color: #0075c2;
      box-shadow: none;
    }
    &--inactive {
      &.theme--light.v-btn.v-btn--has-bg {
        border-radius: 5px;
        border: solid 1px #ccc;
        background-color: rgba(255, 255, 255, 0);
        color: #989898;
      }
    }
  }
  &_actions {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    &-edit {
      display: flex;
    }
    &.isSorting {
      justify-content: flex-end;
    }
  }
  &_edit {
    &.theme--light.v-btn.v-btn--has-bg {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.14;
      letter-spacing: normal;
      text-align: left;
      border-radius: 5px;
      width: 120px;
      height: 36px;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);
    }
    &:disabled {
      color: #ccc;
      background-color: #f3f3f3;
    }
  }
  &_save {
    &.theme--light.v-btn.v-btn--has-bg {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.14;
      letter-spacing: normal;
      text-align: left;
      border-radius: 5px;
      width: 120px;
      height: 36px;
      background-color: #0075c2;
      color: #fff;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);
    }
    &:disabled {
      color: #ccc;
      background-color: #f3f3f3;
    }
  }
  &_cancel {
    &.theme--light.v-btn.v-btn--has-bg {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;
      width: 120px;
      height: 36px;
      background-color: #fff;
      color: #989898;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);
    }
    &:disabled {
      color: #ccc;
      background-color: #f3f3f3;
    }
  }
  &_header-name {
    max-width: 250px;
    &.isSorting {
      padding: 0 !important;
    }
  }
  &_search {
    margin-bottom: 0;
    margin-top: 0;
    padding-top: 0;
    max-width: 327px;
    &.v-input {
      font-size: 18px;
      .v-messages:not(.error--text) {
        .v-messages__message {
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: left;
        }
      }
    }
    .v-text-field__slot {
      padding-left: 0;
    }

    .v-input__slot {
      min-height: 36px !important;
      margin-bottom: 2px;
      .v-input__append-inner {
        margin-top: 9px;
      }
      .v-message__message {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #989898;
      }
    }
    &.theme--light.v-input input {
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.38;
      letter-spacing: normal;
      text-align: left;
      &:-webkit-autofill,
      &:-webkit-autofill::first-line {
        font-family: 'Noto Sans JP', sans-serif;
        font-size: 16px;
        font-weight: normal;
      }
    }

    .v-text-field__details {
      padding: 0 !important;
      padding-top: 0px !important;
      margin-bottom: 0 !important;
    }
  }
  &-infinit_scroll {
    text-align: center;
  }
  &_event {
    &-label {
      margin-right: 5px;
      padding: 0 !important;
    }
  }
  &.theme--light.v-sheet {
    border-radius: 0;
    box-shadow: none;
    padding: 0;
  }
  &_gap-header {
    height: 26px;
  }
  &_select {
    &-icon {
      width: 34px;
      height: 34px;
      padding: 5px 5px 5px 5px;
      background-color: #0075c2;
      border-radius: 50%;
      display: table-cell;
      vertical-align: middle;
      text-align: center;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      .icon-check {
        color: #fff;
        font-size: 25px;
        font-weight: 900;
      }
    }
  }
  &_tbl {
    &-header {
      &--name {
        display: flex;
        align-items: center;
        & > span {
          font-family: 'Noto Sans JP', sans-serif;
          font-size: 12px;
          font-weight: bold;
          color: #4b4b4b;
        }
        .isSorting {
          padding-left: 15px;
        }
      }
    }
    &.v-data-table {
      margin-top: 15px;
    }
    &-name {
      max-width: 100%;
      display: flex;
      align-items: center;
      & > .videoStream {
        pointer-events: none;
        max-width: 100px;
        margin-right: 10px;
      }
      & > .customCheck {
        margin-right: 10px;
      }
    }
    &-registerd,
    &-account {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      color: #4b4b4b;
    }
    .hamburger-menu {
      cursor: grabbing;
      font-size: 24px;
      color: #989898;
      margin-right: 10px;
    }
  }
  th {
    vertical-align: middle;
    min-width: 130px;
    & > span {
      font-family: 'Noto Sans JP', sans-serif;
      font-size: 12px;
      font-weight: bold;
      color: #4b4b4b;
    }
  }
  td {
    vertical-align: middle;
    max-width: 75px;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
  tr {
    cursor: pointer;
    &.selected {
      background-color: #f4f6fc !important;
      border-color: #f4f6fc !important;
    }
  }
  &_btn {
    margin-right: 5px;
  }
  display: flex;
  flex-direction: column;
  &_subtitle {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;
    color: #989898;
  }
  &_title {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 2px;
    color: var(--text-color);
    max-width: 966px;
    @media (min-width: 1280px) {
      width: calc(68vw - 339.77px);
    }
    &_text {
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
    &_type {
      color: var(--warning-color-lighten1);
      font-size: 12px;
      font-weight: 600;
    }
  }
  &_videos {
    position: relative;
  }
  .v-btn {
    &:not(.v-btn--round).v-size--x-small {
      padding-left: 8px;
      padding-right: 8px;
      &.v-btn--outlined {
        padding-left: 7px;
        padding-right: 7px;
        color: #989898;
        border-color: #989898;
      }
    }
    &:not(:last-child) {
      margin-right: 8px;
    }
  }
  & .v-skeleton-loader {
    margin-top: 10px;
  }
  & .v-skeleton-loader__table-heading,
  & .v-skeleton-loader__table-tfoot {
    display: none;
  }
}
</style>
